import React from "react";
import { Form, Label } from "semantic-ui-react";
import AccessibleCheckbox from "../../../../../../components/global_components/AccessibleCheckbox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/pro-light-svg-icons";

interface FilterGroupsProps {
  groupLabel: string;
  groups: { id: number; name: string; visibility: "Public" | "Private" | "Unlisted" }[] | undefined;
  selectedGroups: number[];
  onSelectAll: (checked: boolean) => void;
  onGroupChange: (groupId: number, checked: boolean) => void;
}

const SubscriptionGroupsFilter: React.FC<FilterGroupsProps> = ({
  groupLabel,
  groups,
  selectedGroups,
  onSelectAll,
  onGroupChange,
}) => {
  const allSelected = groups?.every((group) => selectedGroups.includes(group.id));

  return (
    <Form.Field>
      <Label
        className='tw-bg-transparent tw-pb-[.68rem] tw-pl-0 tw-text-[13px] tw-text-base tw-font-bold tw-text-black'
        aria-label={groupLabel}
      >
        {groupLabel}
      </Label>
      <AccessibleCheckbox
        key={`SelectAll-${groupLabel}`}
        label='Select All'
        checked={allSelected}
        onChange={(checked) => onSelectAll(checked)}
      />
      {groups?.map((group) => (
        <AccessibleCheckbox
          key={group.id}
          label={group.name}
          checked={selectedGroups.includes(group.id)}
          onChange={(checked) => onGroupChange(group.id, checked)}
        >
          {group.visibility === "Private" ? <PrivateGroupLabel /> : null}
        </AccessibleCheckbox>
      ))}
    </Form.Field>
  );
};

const PrivateGroupLabel: React.FC = () => {
  return (
    <span>
      <FontAwesomeIcon icon={faLock} className='tw-mr-1 tw-text-black tw-opacity-70' />
      <span className='tw-text-black tw-opacity-70'>Private Group</span>
    </span>
  );
};

export default SubscriptionGroupsFilter;
